import { useEffect, useRef, useState } from 'react';

function useDialogMutation() {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const busy = useRef(false);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  const run = async (operation, onSuccess) => {
    if (busy.current) return false;
    busy.current = true;
    setSaving(true);
    setError('');

    try {
      const result = await operation();
      if (!mounted.current) return Boolean(result?.saved);
      if (!result?.saved) {
        setError(result?.error || 'Your change could not be saved. Please try again.');
        return false;
      }
      onSuccess?.();
      return true;
    } catch (requestError) {
      if (mounted.current) {
        setError(requestError?.message || 'Your change could not be saved. Please try again.');
      }
      return false;
    } finally {
      busy.current = false;
      if (mounted.current) setSaving(false);
    }
  };

  return { run, saving, error };
}

export default useDialogMutation;